import { config } from '../utils/constants/api.constants';

export default (api) => {
  const downloadUploadedFile = (uploadId) => {
    const url =
      config.api.bulkuploadv2.baseUrl + `/api/upload/${uploadId}/download`;
    return new Promise((resolve, reject) => {
      api
        .get(url, {}, {}, 'blob')
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getBulkUpload = (uploadId) => {
    const url =
      config.api.bulkuploadv2.baseUrl +
      config.api.bulkuploadv2.search +
      '?id=' +
      uploadId;
    return new Promise((resolve, reject) => {
      api
        .get(url)
        .then((response) => {
          resolve(response?.data?.length > 0 ? response?.data[0] : null);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  return {
    downloadUploadedFile,
    getBulkUpload,
  };
};
const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
